import { useState } from 'react';
import { BELIEFS } from './beliefs';
import { CollapsibleCard } from '../primitives/CollapsibleCard';
import { FadeUp } from '../primitives/FadeUp';
import { SectionH2 } from '../primitives/SectionH2';
import { SectionLabel } from '../primitives/SectionLabel';
import { useIsMobile } from '../../hooks/useIsMobile';
import { ACCENT, BORDER, FONT_DISPLAY, FONT_MONO, TEXT_SECONDARY } from '../../tokens';

export function BeliefsSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const isMobile = useIsMobile();

  return (
    <section
      style={{
        padding: isMobile ? '60px 20px' : '100px 64px',
        background: 'rgba(8,8,8,0.88)',
        borderTop: `1px solid ${BORDER}`,
      }}
    >
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <FadeUp>
          <div style={{ textAlign: 'center', marginBottom: 52 }}>
            <SectionLabel number="02">What I Believe</SectionLabel>
            <SectionH2 style={{ marginBottom: 16 }}>Five beliefs. No slides. No spin.</SectionH2>
            <p style={{ color: TEXT_SECONDARY, maxWidth: 560, margin: '0 auto', lineHeight: 1.75 }}>
              These aren&rsquo;t marketing pillars. These are how I actually operate, what I optimize for,
              and what you can expect if we work together.
            </p>
          </div>
        </FadeUp>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {BELIEFS.map((belief, i) => (
            <FadeUp key={belief.num} delay={i * 50}>
              <CollapsibleCard
                isOpen={openIndex === i}
                onToggle={() => setOpenIndex(openIndex === i ? null : i)}
                title={
                  <span style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <span style={{ fontFamily: FONT_MONO, fontSize: '0.7rem', color: ACCENT, letterSpacing: '0.12em' }}>
                      {belief.num}
                    </span>
                    <span
                      style={{
                        fontFamily: FONT_DISPLAY,
                        fontSize: 'clamp(1.2rem,1.8vw,1.5rem)',
                        fontWeight: 400,
                        lineHeight: 1.1,
                        letterSpacing: '0.02em',
                        textTransform: 'uppercase',
                        fontStyle: 'normal',
                      }}
                    >
                      {belief.title}
                    </span>
                  </span>
                }
              >
                {belief.body}
              </CollapsibleCard>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
